.e1e2DestinationForm {
  color: #f4f4f4 !important;
  margin: 0 auto;
  text-align: left;
  width: 40%;
  max-width: 836px;

  @media (max-width: 1176px) {
    width: 100%;
  }

  >div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;

    +p {
      margin-top: -0.5rem;

      @media (max-width: 630px) {
        margin-top: -0.2rem;
      }
    }
  }

  >form {
    margin-top: 1rem;

    >div:not(:last-child) {
      margin-bottom: 1rem;

      >div:first-child>label {
        color: #f4f4f4 !important;

        +div {
          margin-top: 0.3125rem;
        }
      }
    }

    span[id="input-primary-error-alert"] {
      margin-top: 0.3125rem;
      color: #e0947b !important;

      svg {
        fill: #e0947b !important;
      }
    }

    >div:nth-child(3)>div>div:first-child {
      width: 100% !important;
    }

    >div:last-child {
      margin-bottom: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem;

      >button {
        min-width: 141px;
      }
    }

    .centralIdFieldWrapper {
      >div:nth-child(2)>div:nth-child(4) {
        color: #3d3d3d !important;
      }
    }
  }

  .backButton {
    position: relative;
    color: #56a1e3 !important;
    background-color: transparent !important;
    border-color: transparent !important;
    padding-left: 2.3rem;

    &:hover {
      background-color: #0d2854 !important;
    }

    >span:first-child {
      position: absolute;
      top: 0.85rem;
      left: 1.3rem;
      color: #56a1e3 !important;

      >svg {
        fill: #56a1e3 !important;
      }
    }
  }
}